import React from "react";
import Samples from "../parts/Samples";
import Problem from "../parts/Problem";

  const stylecalctext2 = {
        fontSize: "24px",
        fontWeight: "bold"
    }
    const stylecalctext3 = {
        paddingTop: "20px",
        fontSize: "18px",
        fontWeight: "normal"
    }
const stylecalcdetails = {
    paddingTop: "30px",
    color: "#FFAB2D",
    fontSize: "18px",
    textDecoration: "underline"
}
export default function Card1() {
    return (
        <>
        <div id="card">
                <div id="courttitle">Внесудебное банкротство с сопровождением юристов «под ключ»</div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm padl">
                            <img src="../images/court.png"/>
                        </div>
                        <div className="col-sm padr" id="calc2">
                            <div style={stylecalctext2}>Посмотрите наши завершенные дела</div>
                            <div style={stylecalctext3}>Мы строго соблюдаем конфиденциальность наших клиентов. В разделе только те судебные решения, на опубликование которых нам дано разрешение.</div>
                            <div style={stylecalcdetails}>Подробнее</div>
                        </div>
                    </div>
                </div>
                <div id="cardtext">Юристы просчитывают все риски и осложнения, которые могут возникнуть в процессе банкротства. Если должник не соответствует требованиям внесудебного банкротства — мы всегда предложим альтернативное решение для списания долгов.
Заявление в МФЦ подадут в присутствии нашего представителя, работники МФЦ не смогут запутать должника и отказать в принятии заявления. Наши специалисты контролируют всю процедуру до получения решения о списание долга.</div>
        </div>
        <Samples/>
        <Problem />
        </>
    )
}